// Components==============
import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import React, { useContext, useEffect, useRef } from 'react';
import './Location.module.scss';
import Button from 'components/UI/Button';
import { SchoolsContext } from 'screens/Schools/Schools';
// =========================

export default function Location({
    index,
    map = false,
    subDivisions,
    item,
    onPress,
}) {
    const { setSelected, selected } = useContext(SchoolsContext);
    const ref = useRef();
    function handleClick() {
        if (map) {
            setSelected(index);
        }
    }

    const subDivisionIndexes = subDivisions?.map((e) => e?.index);
    const active = selected === index || subDivisionIndexes?.includes(selected);

    useEffect(() => {
        if (!active) {
            return;
        }
        onPress(item.contact.lat, item.contact.long);
    }, [active]);

    const variants = {
        active: { scale: 1.25 },
        inactive: { scale: 1 },
    };

    return (
        <motion.div
            styleName={`wrapper ${!map ? 'no-map' : ''} ${
                active ? 'active' : ''
            }`}
            whileHover={{ scale: 1.25 }}
            whileTap={{ scale: 1 }}
            initial={{ x: '-50%', y: '-100%' }}
            onClick={handleClick}
            variants={variants}
            animate={active ? 'active' : 'inactive'}
            ref={ref}
        >
            {/* <img src={location} alt="location" />
            <p>{index}</p> */}
            <FontAwesomeIcon icon={faMapMarkerAlt} />
            {active && (
                <div styleName="tooltip">
                    {item.image && (
                        <div styleName="image-wrapper">
                            <img alt="school" src={item?.image} />
                        </div>
                    )}
                    <div styleName={`content ${item.image ? 'image' : ''}`}>
                        {item.logo && (
                            <div styleName="logo">
                                <img alt="logo" src={item?.logo} />
                            </div>
                        )}
                        <h4>{item?.name}</h4>
                        <p>
                            <span>Locatie</span> {item?.contact?.city}
                        </p>

                        <a
                            target="_blank"
                            rel="noreferrer"
                            href={`${item?.contact.website}`}
                        >
                            <Button>Bekijk website</Button>
                        </a>
                    </div>
                </div>
            )}
        </motion.div>
    );
}
